export default __webpack_public_path__ + "static/portisIcon-f44aba13885f48c3592055dadbc6a506.png";